import clsx from 'clsx';
import styles from './ErrorMessage.module.css';

interface ErrorMessageProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
  > {}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, className, ...props }) => {
  return (
    <p className={clsx(styles.error, className)} data-testid="error-message" {...props}>
      {children}
    </p>
  );
};
